// import styles from "./Header.module.css";d
import React, { useEffect, useRef, useState } from "react";
import {
  Image,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  ButtonGroup,
  Spacer,
  Flex,
  useDisclosure,
  Text,
  Tooltip,
  Switch
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import ShareModal from "../NewPages/Dashboardcomponents/ShareModal";
import ProjectBackupModal from "./ProjectBackupModal";
import CeTools from "./CeTools";
import PeTools from "./PeTools";
import { useToast } from "@chakra-ui/react";
import { downloadFile, downloadURI } from "../Utils/utils";
import { downloadTexApi } from "../api";
import { compileProjectApi, getPdfFile, getPrintPdfFileApi, getProjectFileApi, getTrackPdfFileApi, getWebPdfFileApi, getTrackTexApi } from "../dashboardapi";
import { Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  getNormalPdfApi,
  getXmlApi,
  getTrackPdfApi,
  getWebPdfApi,
  getPrintPdfApi,
} from "../api";
import { useNavigate } from "react-router-dom";
// import Imageupload from "./Imageupload";
// import { color } from "framer-motion";
// import { TbQuestionMark } from "react-icons/tb";
import Help from "./Help";
import { connect, useDispatch } from "react-redux";
import Styling from "./Styling";
import {
  compileTexApi, compileTrackTexApi,
  logout_Api,
  update_project_file_Api
} from "../dashboardapi"
import { Link } from "react-router-dom";
import { useTheme } from "../Themes/ThemeContext";
import { removeToken } from '../Utils/authUtils';
import templatestyle from "../NewPages/Dashboardcomponents/TemplateModal.module.css";
import Modal from "../NewPages/Dashboardcomponents/Modal"
import styles from "./Rawlog.module.css"
function Header(props) {
  // const context = useContext(SearchContext);
  const { projectid, file } = useParams();
  const {
    isOpen: HelpOpen,
    onToggle: onHelpToogle,
    onClose: onHelpClose,
  } = useDisclosure();
  // const {
  //   isOpen: imageUploadOpen,
  //   onToggle: onImageUploadToogle,
  //   onClose: onImageUploadClose,
  // } = useDisclosure();
  const {
    isOpen: isCEToolsOpen,
    onToggle: onCEToolsToggle,
    onClose: onCEToolsClose,
  } = useDisclosure();

  const {
    isOpen: isPEToolsOpen,
    onToggle: onPEToolsToggle,
    onClose: onPEToolsClose,
  } = useDisclosure();

  const {
    isOpen: isStylingOpen,
    onToggle: onStylingToggle,
    onClose: onStylingClose,
  } = useDisclosure();

  const toast = useToast();
  const navigate = useNavigate();
  const projectId = props.projectId;
  const [client, setClient] = useState();
  const projectDetails = props.projectDetails;
  const isInternal = projectDetails.is_internal;
  const projectFiles = props.projectfiles;
  const curFileObj = projectFiles.filter(e => e.name === props.current_file)[0];
  const [clientSelect, setClientSelect] = useState();
  const [showShareModal, setShowShareModal] = useState(false);
  const [showBackupModal, setShowBackupModal] = useState(false);
  const [showSignoutModal, setShowSignOutModal] = useState(false);
  const signoutref = useRef();
  const [projectMode, setProjectMode] = useState(() => {
    const saved = localStorage.getItem('projectmodeswitch');
    return saved === "true";   // convert string to boolean
  });
  const [cleanAux, setCleanAux] = useState(() => {
    const saved = localStorage.getItem('cleanauxswitch');
    return saved === "true";
  });
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const detailFilesArr = projectDetails.uploads;
  useEffect(() => {
    function closedeleteModal(e) {
      if (showSignoutModal && signoutref.current && !signoutref.current.contains(e.target)) {
        setShowSignOutModal(false);
      }
    }
    document.addEventListener('mousedown', closedeleteModal);
    return () => document.removeEventListener('mousedown', closedeleteModal)

  }, [showSignoutModal])

  useEffect(() => localStorage.setItem('projectmodeswitch', projectMode), [projectMode]);
  useEffect(() => localStorage.setItem('cleanauxswitch', cleanAux), [cleanAux]);



  // useEffect(() => {
  //   const data = localStorage.getItem("client");
  //   const jsondata = JSON.parse(data);
  //   props.editToolAction({})

  //   setTimeout(() => {
  //     props.toolStyles({ key: jsondata.client, data: jsondata.styles, isChecked: true });
  //     props.clientSelect('epl');
  //     props.editToolRejected()
  //   }, 5000)

  // }, [])


  // setProjectMode(localStorage.getItem('projectmodeswitch'));

  const downloadTex = async () => {
    toast({
      title: "Downloading",
      description: "Downloading Tex",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getProjectFileApi(projectId, curFileObj.file_uuid);
    toast.closeAll();
    if (result.data) {
      downloadFile(result.data.content, result.data.name, "text/plain");
      toast({
        title: "Downloading Tex.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Downloading Tex Error",
        description: "Error in downloading Tex contact technical team",
        status: "error",
        duration: 2000,
      });
    }
  };

  const downloadTrackTex = async () => {
    toast({
      title: "Downloading",
      description: "Downloading Track Tex",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getTrackTexApi(projectId, curFileObj.file_uuid);
    toast.closeAll();
    if (result.data) {
      downloadFile(result.data.tex, result.data.name, "text/plain");
      toast({
        title: "Downloading Track Tex.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Downloading Track Tex Error",
        description: "Error in downloading Track Tex contact technical team",
        status: "error",
        duration: 2000,
      });
    }
  };

  const downloadNormalPdf = async () => {
    toast({
      title: "Downloading",
      description: "Downloading PDF",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getPdfFile(projectId, curFileObj.file_uuid);
    toast.closeAll();
    if (result.data) {
      downloadURI(
        "data:application/pdf;base64," + result.data.pdf,
        result.data.file + ".pdf"
      );
      toast({
        title: "Downloading PDF.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Download PDF Error",
        description: "Error in downloding PDF contact technical team.",
        status: "error",
        duration: 2000,
      });
    }
  };

  // const downloadProofPdf = async () => {
  //   toast({
  //     title: "Downloading",
  //     description: "Downloading Proof PDF",
  //     status: "info",
  //     duration: null,
  //     icon: (
  //       <Spinner
  //         thickness="4px"
  //         emptyColor="gray.200"
  //         color="blue.500"
  //         size="sm"
  //       />
  //     ),
  //   });

  //   var result = await getProofPdfApi();
  //   toast.closeAll();
  //   if (result.data) {
  //     downloadURI(
  //       "data:application/pdf;base64," + result.data.pdf,
  //       result.data.file + ".pdf"
  //     );
  //     toast({
  //       title: "Downloading Proof PDF.",
  //       description: "Download completed.",
  //       status: "success",
  //       duration: 2000,
  //     });
  //   } else {
  //     toast({
  //       title: "Downloading ProofPDF error",
  //       description: "Error in Downloading ProofPDF contact technical team",
  //       status: "error",
  //       duration: 2000,
  //     });
  //   }
  // };

  const downloadTrackPdf = async () => {
    toast({
      title: "Downloading",
      description: "Downloading Track PDF",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });

    try {

      var result = await getTrackPdfFileApi(projectId, curFileObj.file_uuid);
      toast.closeAll();
      console.log("the result data is ", result);
      let value = "File";
      if (result?.data?.name) {
        const fullName = result.data.name;
        const lastDotIndex = fullName.lastIndexOf(".");
        value = lastDotIndex !== -1 ? fullName.substring(0, lastDotIndex) : fullName;
      }

      console.log("the value name is :", value);
      if (result?.data?.pdf) {
        downloadURI(
          "data:application/pdf;base64," + result.data.pdf,
          value + "_track.pdf"
        );

        toast({
          title: "Downloading Track PDF.",
          description: "Download completed.",
          status: "success",
          duration: 2000,
        });
      } else {
        toast({
          title: "Downloading Track Error.",
          description: result?.data?.error || "File data missing from server response.",
          status: "error",
          duration: 2000,
        });
      }

    } catch (error) {
      toast.closeAll();
      console.error("Critical download process failure:", error);

      toast({
        title: "Downloading Track Error.",
        description: "A network exception or server failure occurred. Please try again.",
        status: "error",
        duration: 2000,
      });
    }
  };
  const downloadPrintPdf = async () => {
    toast({
      title: "Downloading",
      description: "Downloading Print PDF.",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getPrintPdfFileApi(projectId, curFileObj.file_uuid);
    toast.closeAll();
    if (result?.data) {
      let filename = curFileObj.name.replace("_web", "");
      downloadURI(
        "data:application/pdf;base64," + result?.data?.pdf,
        filename + "-print.pdf"
      );
      toast({
        title: "Downloading Print PDF.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Downloading Print PDF Error.",
        description: result?.data?.error,
        status: "error",
        duration: 2000,
      });
    }
  };

  const downloadWebPdf = async () => {
    toast({
      title: "Downloading",
      description: "Downloading Web PDF.",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getWebPdfFileApi(projectId, curFileObj.file_uuid);
    toast.closeAll();
    if (result?.data) {
      let filename = curFileObj.name.replace("_web", "");
      downloadURI(
        "data:application/pdf;base64," + result?.data?.pdf,
        filename + ".pdf"
      );
      toast({
        title: "Downloading Web PDF.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Downloading Web PDF Error.",
        description: result?.data?.error,
        status: "error",
        duration: 2000,
      });
    }
  };

  const downloadXML = async () => {
    toast({
      title: "Downloading.",
      description: "Downloading XML.",
      status: "info",
      duration: null,
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    var result = await getXmlApi();
    toast.closeAll();
    if (result?.data) {
      downloadURI(
        "data:text/xml;charset=utf-8," +
        result?.data?.xml.replace(/\n/g, "%0D%0A"),
        result?.data?.file + ".xml"
      );
      toast({
        title: "Downloading XML.",
        description: "Download completed.",
        status: "success",
        duration: 2000,
      });
    } else {
      toast({
        title: "Downloading XML Error.",
        description: "Error in downloading XML please contact technical team.",
        status: "error",
        duration: 2000,
      });
    }
  };

  // const logout = async () => {
  //   var result = await deleteTokenApi();
  //   if (result.data) {
  //     toast({
  //       title: "Logout Successful.",
  //       description: "Current session has been logged out.",
  //       status: "success",
  //       duration: 2000,
  //     });
  //     localStorage.setItem("token", null);
  //     navigate("/loginnew/signIn");
  //   }
  // };

  const handleSignOut = async (e) => {
    let response = await logout_Api();
    if (response.data) {
      removeToken()
      navigate("/loginnew/signIn")
      toast({
        title: "Signed Out Successfully",
        description: "",
        status: "success",
        duration: 2000,
        isClosable: "true"
      })
    } else {
      toast({
        title: "Problem signing out",
        description: "Please try again later",
        status: "error",
        duration: 2000,
        isClosable: "true"
      })
    }
  }

  const submitTex = async () => {
    console.log(props.query);
    let query = props.query;
    let unanswered = [];
    query && query.forEach((qry) => {
      if (qry.ans === undefined || qry.ans === "") {
        unanswered.push(qry)
      }
    })
    if (unanswered && unanswered.length === 0) {
      toast({
        title: "File Submitted Successfully",
        description: "",
        status: "success",
        duration: 2000
      })
      removeToken();
      navigate("/loginnew/signIn");
    } else {
      toast({
        title: "Query not answered",
        description: "Please answer all the queries before submitting",
        status: "warning",
        duration: 2000
      })
    }
    // var result = await saveTexApi(props.tex, props.correction);
    // if (result.data) {
    //   toast({
    //     title: "Saving Tex.",
    //     description: "Save successfull.",
    //     status: "success",
    //     duration: 1000,
    //   });
    //   toast({
    //     title: "Submit",
    //     description: "Submitting the file for further processing.",
    //     status: "info",
    //     duration: null,
    //     icon: (
    //       <Spinner
    //         thickness="4px"
    //         emptyColor="gray.200"
    //         color="blue.500"
    //         size="sm"
    //       />
    //     ),
    //   });
    //   var res = await submitFileApi();
    //   if (res.data) {
    //     toast.closeAll();
    //     toast({
    //       title: "Success.",
    //       description: "Compilation successfull.",
    //       status: "success",
    //       duration: 2000,
    //     });
    //     await deleteTokenApi();
    //     localStorage.setItem("token", null);
    //     navigate("/login");
    //   } else {
    //     console.log(res.error.response.data.log);
    //     toast.closeAll();
    //     toast({
    //       title: "Error.",
    //       description: "Error in compilation, please check log file.",
    //       status: "error",
    //       duration: 2000,
    //     });
    //   }
    // }
  };
  //MARK:Compile Tex
  const clearAllGutterDecorations = (editor) => {
    console.log("it is coming inside the clearallGutterDecorations")
    const session = editor.getSession();
    const lineCount = session.getLength();
    for (let i = 0; i < lineCount; i++) {
      console.log("the loop is running to remove the icons")
      editor.getSession().removeGutterDecoration(i, styles.myIconGutter);
    }
  };

  const compileTex = async () => {
    // console.log("it is compiling the tex file 1");
    let prevScroll;
    if (props.pdfContainer) {
      prevScroll = props?.pdfContainer?.current?.scrollTop;
    } else {
      prevScroll = 0;
    }
    if (props.editorRef?.current?.editor) {
      clearAllGutterDecorations(props.editorRef.current.editor);
    }
    toast({
      title: "Saving Tex.",
      description: "Saving file, Please wait",
      status: "info",
      duration: null,
    });
    // console.log(projectFiles);
    // console.log(curFileObj);
    let result = await update_project_file_Api(projectId, curFileObj.file_uuid, curFileObj.name, props.tex)
    if (result) {
      toast.closeAll();
      toast({
        title: "File saved",
        description: "Saved successfully",
        status: "success",
        duration: 2000,
      });
      toast({
        title: "Compiling",
        description: "Compiling File...",
        status: "info",
        duration: null,
        icon: (
          <Spinner
            thickness="4px"
            emptyColor="gray.200"
            color="blue.500"
            size="sm"
          />
        ),
      });
      props.setPdfStatus({ loading: true, error: null });
      const startTime = Date.now();
      var res = await compileTexApi(projectId, curFileObj.file_uuid, cleanAux);
      const endTime = Date.now();
      const timeTaken = ((endTime - startTime) / 1000).toFixed(2);
      if (res.data) {
        toast.closeAll();
        toast({
          title: "Success.",
          description: `Compilation successful in ${timeTaken}s.`,
          status: "success",
          duration: 3000,
        });

        isInternal ? navigate("#correction") : navigate("#pdf");
        props.setRightController((prevState) => ({
          ...prevState,
          view: "pdf",
          pdfData: "data:application/pdf;base64," + res.data.pdf,
          prevScroll: prevScroll,
          rawData: ""
        }));
      } else {
        props.setPdfStatus({ loading: false, error: "Compilation Error" });
        toast.closeAll();
        // console.log(res.error.error);
        // console.log(res.error.log);
        toast({
          title: "Error.",
          description: "Error in compilation, please check log file.",
          status: "error",
          duration: 2000,
        });
        navigate("#rawlog");
        props.setRightController((prevState) => ({
          ...prevState,
          view: "raw",
          rawData: res.error.log,
          errorData: res.error.error
        }));
      }
    }
  };

  //MARK:Compile Project
  const compileProject = async () => {
    // console.log("it is compiling the tex file 2");
    let prevScroll;
    if (props.pdfContainer) {
      prevScroll = props?.pdfContainer?.current?.scrollTop;
    } else {
      prevScroll = 0;
    }
    if (props.editorRef?.current?.editor) {
      clearAllGutterDecorations(props.editorRef.current.editor);
    }
    toast({
      title: "Saving Tex.",
      description: "Saving file, Please wait",
      status: "info",
      duration: null,
    });
    console.log(curFileObj);
    let result = await update_project_file_Api(projectId, curFileObj.file_uuid, curFileObj.name, props.tex);
    if (result) {
      toast.closeAll();
      toast({
        title: "File saved",
        description: "Saved successfully",
        status: "success",
        duration: 2000,
      });

      if (detailFilesArr) {
        const check = detailFilesArr.some(element => {
          return element.hasOwnProperty('is_index')
        });
        console.log(check);
        if (check) {
          toast({
            title: "Compiling",
            description: "Compiling as Project...",
            status: "loading",
          });
          props.setPdfStatus({ loading: true, error: null });
          const startTime = Date.now();
          let result = await compileProjectApi(projectId, cleanAux);
          const endTime = Date.now();
          const timeTaken = ((endTime - startTime) / 1000).toFixed(2);
          console.log(result);

          if (result.data) {
            toast.closeAll();
            toast({
              title: "Success.",
              description: `Project Compilation successful in ${timeTaken}s.`,
              status: "success",
              duration: 3000,
            });

            isInternal ? navigate("#correction") : navigate("#pdf");
            props.setRightController((prevState) => ({
              ...prevState,
              view: "pdf",
              pdfData: "data:application/pdf;base64," + result.data.pdf,
              prevScroll: prevScroll,
              rawData: ""
            }));
          } else {
            props.setPdfStatus({ loading: false, error: "Compilation Error" });
            toast.closeAll();
            toast({
              title: "Error.",
              description: "Error in compilation, please check log file.",
              status: "error",
              duration: 2000,
            });
            navigate("#rawlog")
            props.setRightController((prevState) => ({
              ...prevState,
              view: "raw",
              rawData: result.error.log,
              errorData: result.error.error
            }));
          }
        } else {
          toast({
            title: "Can't Compile Project",
            description: "No File is Marked as Index",
            status: "error",
            duration: 2000,
            isClosable: true
          });
        }
      }
    }
  };





  //MARK:Tracktex
  const compileTrackTex = async () => {
    // console.log("it is compiling the tex file 3");
    let prevScroll;
    if (props.pdfContainer) {
      prevScroll = props?.pdfContainer?.current?.scrollTop;
    } else {
      prevScroll = 0;
    }
    if (props.editorRef?.current?.editor) {
      clearAllGutterDecorations(props.editorRef.current.editor);
    }
    toast({
      title: "Saving Tex.",
      description: "Saving file, Please wait",
      status: "info",
      duration: null,
    });
    let result = await update_project_file_Api(projectId, curFileObj.file_uuid, curFileObj.filename, props.tex)
    if (result.data) {
      toast.closeAll();
      toast({
        title: "File Saved",
        description: "Saved successfully.",
        status: "success",
        duration: 2000,
      });
      toast({
        title: "Compiling",
        description: "Compiling track tex document.",
        status: "info",
        duration: null,
        icon: (
          <Spinner
            thickness="4px"
            emptyColor="gray.200"
            color="blue.500"
            size="sm"
          />
        ),
      });
      props.setPdfStatus({ loading: true, error: null });
      const startTime = Date.now();
      var res = await compileTrackTexApi(projectId, curFileObj.file_uuid, cleanAux);
      const endTime = Date.now();
      const timeTaken = ((endTime - startTime) / 1000).toFixed(2);
      toast.closeAll();
      if (res.data) {
        toast({
          title: "Success.",
          description: `Compilation successful in ${timeTaken}s.`,
          status: "success",
          duration: 3000,
        });
        isInternal ? navigate("#correction") : navigate("#pdf");
        props.setRightController((prevState) => ({
          ...prevState,
          view: "pdf",
          pdfData: "data:application/pdf;base64," + res.data.pdf,
          prevScroll: prevScroll,
          rawData: ""
        }));
      } else {
        navigate("#rawlog")
        toast({
          title: "Error.",
          description: "Error in compilation, please check log file.",
          status: "error",
          duration: 2000,
        })
        props.setRightController((prevState) => ({
          ...prevState,
          view: "raw",
          rawData: res.error.log,
          errorData: res.error.error
        }));
      }
    }
  };

  // useEffect(() => {
  //   if (props.TexcompileTrig) {
  //     compileTex();          // your actual compile function
  //     dispatch(props.compileTrigReset());
  //   }
  // });

  //MARK:useEffects
  useEffect(() => {
    if (props.TexcompileTrig) {
      if (projectMode) { compileProject(); }
      else { compileTex(); }
      //compile function or project function
      dispatch({ type: "RESET_COMPILE" });
    }
  }, [props.TexcompileTrig]);

  useEffect(() => {
    if (props.TrackcompileTrig) {
      compileTrackTex();          //track compile function
      dispatch({ type: "RESET_TRACK_COMPILE" });
    }
  }, [props.TrackcompileTrig]);


  useEffect(() => {
    //console.log(props);  
    props.compileTex(compileTex);
    props.trackCompile(compileTrackTex);
  }, [props.tex, props.correction, compileTex, compileTrackTex]);

  useEffect(() => {
    if (clientSelect) {
      props.clientSelect(clientSelect)
    }
  }, [clientSelect]);

  useEffect(() => {
    props.toggleProjectMode(projectMode);
  }, [projectMode]);

  //console.log(props.projectMode);

  // display the filename with ... after certain length.
  // const getfilename = () => {
  //   if (props.filename.length > 15) {
  //     return (`${props.filename.substring(0, 15)}...`);
  //   } else {
  //     return (props.filename);
  //   }
  // };


  //MARK: Header
  return (
    <Flex minWidth="max-content" height="100%" alignItems="center" justifyContent="space-between" gap={2} backgroundColor={"var(--bg-overlay)"}>
      <Box ml={5} width="144px">
        {/* <a href="/dashboard/myprojects">
          <Image
            // width="180px"
            // height="32px"
            objectFit="contain"
            src={theme === "dark" ? process.env.PUBLIC_URL + "/images/dark-logo.png" : "/NewPages/Homepage/LogoMobile.svg"}
            alt="EditLatex"
          />
        </a> */}
        <Link to={"/home"} tabIndex={0}>
          {
            theme === "dark" ? (
              <img alt='editLatex logo' src={process.env.PUBLIC_URL + "/NewPages/Dashboard/darklogo.png"} />
            ) :
              <img alt="editLatex logo" src={process.env.PUBLIC_URL + "/NewPages/Homepage/TransformaLogo.png"} />
          }
        </Link>
        {/* <Box display="flex" justifyContent="space-evenly" alignItems="center">
          <Text
            height="12px"
            width="65px"
            fontSize="10px"
            fontFamily="Roboto, sans-serif"
            color="var(--text-primary)"
            textAlign="center"
          >
            Powered by
          </Text>
          <a href="https://www.transforma.in/" target="_">
            <Image
              cursor="pointer"
              alt="transforma logo"
              src={
                process.env.PUBLIC_URL + "/images/Redesignpics/transforma.svg"
              }
            />
          </a>
        </Box> */}
      </Box>
      <Flex>

        <Box
          height="48px"
          width="100%"
          marginLeft="76px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="12px"

          border="1px solid var(--border-none)"
          padding="10px"
        >
          <Link
            to={"/dashboard/myprojects"}
            height="36px"
            width="100%"
            borderRadius="50%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            backgroundColor="var(--bg)"
            onClick={() => { localStorage.removeItem("leftpanel"); localStorage.removeItem("clientwidth"); localStorage.removeItem("clientheight") }}
          >
            <Tooltip label="Go To My Projects">
              <Flex backgroundColor="var(--bg-overlay)" padding={"4px 10px"} gap={2} borderRadius={"8px"}>
                {/* <Image
                  height={"20px"}
                  width={"20px"}
                  src={
                    process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/folders.svg"
                  }
                ></Image> */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_41_1680)">
                    <path d="M9 4H12L14 6H19C19.5304 6 20.0391 6.21071 20.4142 6.58579C20.7893 6.96086 21 7.46957 21 8V15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H9C8.46957 17 7.96086 16.7893 7.58579 16.4142C7.21071 16.0391 7 15.5304 7 15V6C7 5.46957 7.21071 4.96086 7.58579 4.58579C7.96086 4.21071 8.46957 4 9 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 17V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21071 4.46957 8 5 8H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_41_1680">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <Box>
                  <p style={{ fontSize: "14px" }}>My Projects</p>
                </Box>
              </Flex>
            </Tooltip>
          </Link>

          <Tooltip label="Project Title">
            <Box
              height="48px"
              width="fit-content"
              marginLeft="8px"
              display="flex"
              justifyContent="space-around"
              alignItems="center"
              // borderRadius="12px"
              // backgroundColor="#fff"
              // border="1px solid #CCCBD3"
              p="5px"
            >
              <Box
                height="36px"
                width="36px"
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                backgroundColor="var(--bg-overlay)"
              >
                {/* <Image
                  src={
                    process.env.PUBLIC_URL + "/images/Redesignpics/filenameicon.svg"
                  }
                ></Image> */}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.875 8.75C6.70924 8.75 6.55027 8.81585 6.43306 8.93306C6.31585 9.05027 6.25 9.20924 6.25 9.375C6.25 9.54076 6.31585 9.69973 6.43306 9.81694C6.55027 9.93415 6.70924 10 6.875 10H13.125C13.2908 10 13.4497 9.93415 13.5669 9.81694C13.6842 9.69973 13.75 9.54076 13.75 9.375C13.75 9.20924 13.6842 9.05027 13.5669 8.93306C13.4497 8.81585 13.2908 8.75 13.125 8.75H6.875ZM6.25 11.875C6.25 11.7092 6.31585 11.5503 6.43306 11.4331C6.55027 11.3158 6.70924 11.25 6.875 11.25H13.125C13.2908 11.25 13.4497 11.3158 13.5669 11.4331C13.6842 11.5503 13.75 11.7092 13.75 11.875C13.75 12.0408 13.6842 12.1997 13.5669 12.3169C13.4497 12.4342 13.2908 12.5 13.125 12.5H6.875C6.70924 12.5 6.55027 12.4342 6.43306 12.3169C6.31585 12.1997 6.25 12.0408 6.25 11.875ZM6.25 14.375C6.25 14.2092 6.31585 14.0503 6.43306 13.9331C6.55027 13.8158 6.70924 13.75 6.875 13.75H9.375C9.54076 13.75 9.69973 13.8158 9.81694 13.9331C9.93415 14.0503 10 14.2092 10 14.375C10 14.5408 9.93415 14.6997 9.81694 14.8169C9.69973 14.9342 9.54076 15 9.375 15H6.875C6.70924 15 6.55027 14.9342 6.43306 14.8169C6.31585 14.6997 6.25 14.5408 6.25 14.375Z" fill="currentColor" />
                  <path d="M11.875 0H5C4.33696 0 3.70107 0.263392 3.23223 0.732233C2.76339 1.20107 2.5 1.83696 2.5 2.5V17.5C2.5 18.163 2.76339 18.7989 3.23223 19.2678C3.70107 19.7366 4.33696 20 5 20H15C15.663 20 16.2989 19.7366 16.7678 19.2678C17.2366 18.7989 17.5 18.163 17.5 17.5V5.625L11.875 0ZM11.875 1.25V3.75C11.875 4.24728 12.0725 4.72419 12.4242 5.07583C12.7758 5.42746 13.2527 5.625 13.75 5.625H16.25V17.5C16.25 17.8315 16.1183 18.1495 15.8839 18.3839C15.6495 18.6183 15.3315 18.75 15 18.75H5C4.66848 18.75 4.35054 18.6183 4.11612 18.3839C3.8817 18.1495 3.75 17.8315 3.75 17.5V2.5C3.75 2.16848 3.8817 1.85054 4.11612 1.61612C4.35054 1.3817 4.66848 1.25 5 1.25H11.875Z" fill="currentColor" />
                </svg>
              </Box>

              <Text height="auto" width="fit-content" p="5px">
                {props.filename}
              </Text>
            </Box>
          </Tooltip>
        </Box>

      </Flex>

      {/* <Spacer /> */}
      <div>
        <ButtonGroup mr="4" zIndex={10} padding={"5px"} borderRadius={"14px"}>
          <Menu style={{ float: "left" }}>
            <MenuButton
              // hidden={isInternal}
              variant="unstyled"
              as={Button}
              border={"none"}
              // background={"#EEEEF0"}
              rightIcon={<ChevronDownIcon />}
              color="var(--text-primary)"
              padding="0 10px"
              fontSize="md"
              fontFamily="Roboto, sans-serif"
              fontWeight={500}
              display="flex"
              alignItems="center"
              _hover={{ backgroundColor: "var(--hover)" }}
              _active={{ backgroundColor: "var(--active)" }}
              onClick={() => { onStylingToggle(); props.showclient(); }}
            >
              Editing Tools
            </MenuButton>
            <Styling ace={props.editorRef} isOpen={isStylingOpen} onClose={onStylingClose} currentClient={"epl"} toast={toast} setRightController={props.setRightController} projectDetails={props.projectDetails} control={props.control} />
            {/* <MenuList portal={false} className="editor-menu" >
            <MenuItem onClick={() => { onStylingToggle(); setClientSelect("epl") }}>EPL</MenuItem>
            <MenuItem onClick={() => { onStylingToggle(); setClientSelect("edp") }}>EDP</MenuItem>
            <Styling isOpen={isStylingOpen} onClose={onStylingClose} currentClient={"epl"} />
          </MenuList> */}
          </Menu>

          {/* <Menu>
          <MenuButton
            hidden={isInternal}
            variant="unstyled"
            as={Button}
            border={"none"}
            background={"var(--bg)"}
            rightIcon={<ChevronDownIcon />}
            color="var(--text-primary)"
            padding="0 10px"
            fontSize="md"
            fontFamily="Roboto, sans-serif"
            fontWeight={500}
            display="flex"
            alignItems="center"
            _hover={{ backgroundColor: "var(--hover)" }}
            _active={{ backgroundColor: "var(--active)" }}
          >
            Tools
          </MenuButton>
          <MenuList portal={false} className="editor-menu" hidden={isInternal}>
            <MenuItem onClick={onPEToolsToggle}>PE Tools</MenuItem>
            <PeTools
              processTools={props.processTools}
              projectid={projectid}
              isOpen={isPEToolsOpen}
              onClose={onPEToolsClose}
            />
            <MenuItem onClick={onCEToolsToggle}>CE Tools</MenuItem>
            <CeTools
              processTools={props.processTools}
              projectid={projectid}
              isOpen={isCEToolsOpen}
              onClose={onCEToolsClose}
            />
          </MenuList>
        </Menu> */}
          {/* MARK:Menulist */}
          <Menu closeOnSelect={false}>
            <MenuButton
              variant="unstyled"
              as={Button}

              rightIcon={<ChevronDownIcon />}
              fontSize="md"
              color="var(--text-primary)r"
              padding="0 10px"
              fontFamily="Roboto, sans-serif"
              fontWeight={500}
              display="flex"
              alignItems="center"
              _hover={{ backgroundColor: "var(--hover)" }}
              _active={{ backgroundColor: "var(--active)" }}
            >
              Compile
            </MenuButton>
            <MenuList portal={false} className="editor-menu">
              <MenuItem id="projectswitch" justifyContent="space-between" alignItems="flex-end">Project Mode<Switch isChecked={projectMode}
                onChange={() => setProjectMode(!projectMode)}
                sx={{
                  ".chakra-switch__track": {
                    _checked: { bg: "#000000" }
                  }
                }
                }></Switch></MenuItem>
              <MenuItem id="cleanauxswitch" justifyContent="space-between" alignItems="flex-end">Clean Caches <Switch isChecked={cleanAux}
                onChange={() => setCleanAux(!cleanAux)}
                sx={{
                  ".chakra-switch__track": {
                    _checked: { bg: "#000000" }
                  }
                }
                }></Switch></MenuItem>
              <MenuItem closeOnSelect={true} onClick={projectMode ? compileProject : compileTex}>Latex</MenuItem>
              <MenuItem closeOnSelect={true} onClick={compileTrackTex}>Track Latex</MenuItem>
            </MenuList>
          </Menu>

          <Menu>
            <MenuButton
              variant="unstyled"
              as={Button}

              rightIcon={<ChevronDownIcon />}
              fontSize="md"
              color="var(--text-primary)"
              padding="0 10px"
              fontFamily="Roboto, sans-serif"
              fontWeight={500}
              display="flex"
              alignItems="center"
              _hover={{ backgroundColor: "var(--hover)" }}
              _active={{ backgroundColor: "var(--active)" }}
            >
              Download
            </MenuButton>
            <MenuList portal={false} className="editor-menu">
              <MenuItem onClick={downloadTex}>Tex</MenuItem>
              <MenuItem onClick={downloadTrackTex}>Track Tex</MenuItem>
              <MenuItem onClick={downloadXML}>XML</MenuItem>
              <MenuItem onClick={downloadNormalPdf}>PDF</MenuItem>
              <MenuItem onClick={downloadTrackPdf}>Track PDF</MenuItem>
              {/* <MenuItem onClick={downloadProofPdf}>Proof PDF</MenuItem> */}
              <MenuItem onClick={downloadWebPdf}>Web PDF</MenuItem>
              <MenuItem onClick={downloadPrintPdf}>Print PDF</MenuItem>
              {(!projectDetails?.permission || projectDetails?.permission === "owner") && (
                <MenuItem onClick={() => setShowBackupModal(true)}>Backups</MenuItem>
              )}
            </MenuList>
          </Menu>

          <Menu style={{ float: "left" }}>
            <MenuButton
              hidden={isInternal}
              variant="unstyled"
              as={Button}
              border={"none"}
              // background={"#EEEEF0"}
              rightIcon={<ChevronDownIcon />}
              color="var(--text-primary)"
              padding="0 10px"
              fontSize="md"
              fontFamily="Roboto, sans-serif"
              fontWeight={500}
              display="flex"
              alignItems="center"
              _hover={{ backgroundColor: "var(--hover)" }}
              _active={{ backgroundColor: "var(--active)" }}
              onClick={() => { setShowShareModal(true) }}
            >
              Share
            </MenuButton>
            <ShareModal
              show={showShareModal}
              onClose={() => setShowShareModal(false)}
              project={{
                name: props.filename,
                uuid: projectid
              }}
            />
          </Menu>
        </ButtonGroup>

        {/*MARK:Help part */}
        <ButtonGroup mr="4" padding={"5px"} borderRadius={"14px"}>
          <Button
            variant="unstyled"

            display="flex"
            onClick={onHelpToogle}
            padding="0 10px"
            fontSize="md"
            fontWeight={400}
            _hover={{ backgroundColor: "var(--hover)" }}
            _active={{ backgroundColor: "var(--active)" }}
          >
            Help
          </Button>

          <Button
            hidden={!isInternal}
            backgroundColor="var(--bg)"
            width=""
            padding={"0 10px"}
            fontSize="md"
            fontWeight={400}
            // border="1px"
            // borderRadius="4px"
            // borderColor="black"
            color="black"
            _hover={{ backgroundColor: "var(--hover)" }}
            _active={{ backgroundColor: "var(--active)" }}
            onClick={submitTex}
          >
            Submit
          </Button>

          <Button
            hidden={isInternal}
            variant="unstyled"

            display="flex"
            onClick={() => { setShowSignOutModal(true) }}
            padding="0 10px"
            fontSize="md"
            fontWeight={400}
            _hover={{ backgroundColor: "var(--hover)" }}
            _active={{ backgroundColor: "var(--active)" }}
          >
            Sign Out
          </Button>

          <Modal show={showSignoutModal}>
            <div ref={signoutref} className={templatestyle.warningcontainer}>
              <div className={templatestyle.TemplateHeaderContainer}>
                <p >Sign Out</p>
                <button onClick={() => setShowSignOutModal(false)}>

                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>

              </div>

              <div className={templatestyle.warningContent}>
                <p>Are your sure. You want to signout?</p>
              </div>
              <div className={templatestyle.warningbuttonsection}>
                <button className={templatestyle.cancelBtn} onClick={() => { setShowSignOutModal(false); }} >Cancel</button>
                <button className={templatestyle.DeleteWarningbtn} onClick={() => { handleSignOut(); }}>Signout</button>
              </div>
            </div>
          </Modal>

          {/* {HelpOpen ? (
          <Button
            variant="unstyled"
            backgroundColor="white"
            display="flex"
            onClick={onHelpToogle}
            _hover={{ backgroundColor: "#edf2f7" }}
            _active={{ backgroundColor: "#EEEEF0" }}
          >
            {/* <img
              style={{ height: "60px", width: "60px" }}
              alt="Help-icon"
              src={process.env.PUBLIC_URL + "/images/Redesignpics/HelpOpen.svg"}
            /> */}
          {/* Help */}
          {/* </Button> */}
          {/* ) : ( */}
          {/* <Button
            variant="unstyled"
            backgroundColor="white"
            display="flex"
            onClick={onHelpToogle}
            _hover={{ backgroundColor: "#edf2f7" }}
            _active={{ backgroundColor: "#EEEEF0" }}
          >
            {/* <img
              style={{ height: "60px", width: "60px" }}
              alt="Help-icon"
              src={process.env.PUBLIC_URL + "/images/Redesignpics/Help.svg"}
            /> */}
          {/* Help */}
          {/* </Button> */}
          {/* )} */}

          <Help
            isOpen={HelpOpen}
            onClose={onHelpClose}
            setChange={props.setChange}
            change={props.change}
          />

          <ProjectBackupModal
            isOpen={showBackupModal}
            onClose={() => setShowBackupModal(false)}
            project={{
              uuid: projectId,
              name: props.filename || projectDetails?.name
            }}
          />

          {/* <Button colorScheme='gray'>Reset</Button>  */}
        </ButtonGroup>
      </div>
    </Flex >
  );
}

const mapStateToProps = (state) => ({
  tex: state.uploadTex.tex,
  correction: state.correction.corrections,
  query: state.queries.queries,
  TexcompileTrig: state.compileTrig.compileTrigger,
  TrackcompileTrig: state.compileTrackTrig.compileTrackTrigger,
  projectMode: state.projectMode.projectMode,
  editToolStyles: state.toolStyles.function,
  isChecked: state.toolStyles.isChecked,
});

const mapDispatchToProps = (dispatch) => {
  return {
    compileTex: (data) => dispatch({ type: "compile", payload: data }),
    trackCompile: (data) => dispatch({ type: "trackcompile", payload: data }),
    clientSelect: (data) => dispatch({ type: "clientselect", payload: data }),
    toggleProjectMode: (value) => dispatch({ type: "projectMode", payload: value }),
    // compileTrigger: () => dispatch({ type: "TRIGGER_COMPILE" }),
    compileTrigger: () => dispatch({ type: "RESET_COMPILE" }),
    // compileTrackTrigger: () => dispatch({ type: "TRIGGER_TRACK_COMPILE" }),
    compileTrackTrigger: () => dispatch({ type: "RESET_TRACK_COMPILE" }),
    eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    // editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    showclient: () => dispatch({ type: "changeclient" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null)(Header);

// export default Header;